import { ReactNode } from "react";
import { Flex, Color, Text, HorizontalDivider, Toggle } from "src/elements";
import { OTouchedMark } from "./OTouched";

interface Props {
  title: string;
  area: string;
  width?: string;
  toggleValue?: boolean;
  setToggleValue?: (value: boolean) => void;
  /** Controls on the header line, right of the title (e.g. a single input). */
  headerExtra?: ReactNode;
  isDisabled?: boolean;
  children?: ReactNode;

  path?: string;
}

export const RulesSection = ({
  title,
  area,
  width = "100%",
  toggleValue,
  setToggleValue,
  headerExtra,
  isDisabled,
  children,
  path,
}: Props) => {
  return (
    <Flex
      width={width}
      background={Color.lightGray}
      column
      borderRadius="3px"
      overflow="hidden"
      gridArea={area}
    >
      <Flex
        background={Color.lightGrayHover}
        padding="5px 10px"
        justify={headerExtra ? "space-between" : "center"}
        align="center"
        gap="10px"
      >
        <Text variant="body1" color={(isDisabled && Color.textDisabled) || Color.textMain}>
          {title}
        </Text>

        <OTouchedMark path={path} />

        {toggleValue !== undefined && setToggleValue !== undefined && (
          <Toggle value={toggleValue} setValue={setToggleValue} isDisabled={isDisabled} />
        )}

        {headerExtra}
      </Flex>

      <HorizontalDivider color={Color.textDisabled} />

      <Flex column>{children}</Flex>
    </Flex>
  );
};
